import { QuietButton, Sidebar, TruncatedText } from "@nulogy/components";
import { expandedSidebarWidth, sidebarExpandButtonWidth } from "components/pages/schedule/sidebarSizes";
import UIStateContext from "contexts/UIStateContext";
import useSlideOutState from "hooks/state/useSlideOutState";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import FilterSidebarContainer from "./FilterSidebarContainer";
import WorkOrderDetailsContainer from "./workOrderDetails/WorkOrderDetailsContainer";

const TruncatedHeading = styled(TruncatedText)(({ theme }) => ({
  fontSize: theme.fontSizes.heading2,
  fontWeight: theme.fontWeights.normal,
  lineHeight: theme.lineHeights.heading2,
  marginBottom: 0,
  marginTop: 0,
  maxWidth: "313px",
}));

export default function SlideOutPanel({ onClearFilters }) {
  const {
    state: { sidebarOpen },
  } = useContext(UIStateContext);
  const { isOpen, closeSlideOut: onClose, isFilterMode, workOrderCode } = useSlideOutState();

  const showSidebar = isOpen();

  // Need ability to pop calendars over other sidebar, but not to animate over
  // other sidebar
  const [zIndex, setZIndex] = useState(showSidebar ? 11 : 10);

  useEffect(() => {
    if (!showSidebar) {
      setZIndex(10);
    }
  }, [showSidebar]);

  const handleCloseSlideOutPanel = () => {
    onClose();
  };

  const handleAnimationComplete = () => {
    if (showSidebar) {
      setZIndex(11);
    }
  };

  return (
    <Sidebar
      closeButtonTestId={isFilterMode() ? "spec-filter-close-button" : "spec-work-order-details-close-button"}
      closeOnOutsideClick={false}
      duration={sidebarOpen && !showSidebar ? 0.5 : 0.25}
      footer={isFilterMode() ? <QuietButton onClick={onClearFilters}>Clear filters</QuietButton> : null}
      isOpen={showSidebar}
      offset={sidebarOpen ? expandedSidebarWidth : sidebarExpandButtonWidth}
      onAnimationComplete={handleAnimationComplete}
      onClose={handleCloseSlideOutPanel}
      overlay={false}
      style={{ zIndex }}
      title={isFilterMode() ? "Work order filters" : <TruncatedHeading fullWidth>{workOrderCode}</TruncatedHeading>}
      width="410px"
    >
      <FilterSidebarContainer />
      <WorkOrderDetailsContainer />
    </Sidebar>
  );
}
